// extracted by css-extract-rspack-plugin
export default {"badge":"sKzZu","hidden":"yW0yc"};